import styled from '@emotion/styled';
import type { ChangeEvent, FunctionComponent } from 'react';

import { RequiredSectionTitle } from './RequiredSectionTitle';

const StyledInput = styled.div({
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    background: '#fbfbff',
    borderRadius: '0.625rem',
    boxSizing: 'border-box',
    display: 'inline-flex',
    gap: '0.625rem',
    justifyContent: 'flex-start',
    minHeight: '5rem',
    outline: '0.0625rem #e7e7e7 solid',
    outlineOffset: '-0.0625rem',
    overflow: 'hidden',
    padding: '0.5rem 0.75rem',
    width: '100%',
});

const InputContainer = styled.div({
    width: '100%',
});

const TextareaElement = styled.textarea({
    '&::placeholder': {
        color: '#9a9a98',
    },
    background: 'transparent',
    border: 'none',
    color: '#040f16',
    fontFamily: 'FT Regola Neue',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    minHeight: '4rem',
    outline: 'none',
    resize: 'none',
    width: '100%',
});

type FeedbackTextInputProps = {
    readonly onChange: (value: string) => void;
    readonly placeholder: string;
    readonly required?: boolean;
    readonly title: string;
    readonly value: string;
};

export const FeedbackTextInput: FunctionComponent<FeedbackTextInputProps> = ({
    onChange,
    placeholder,
    required = false,
    title,
    value,
}) => {
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
        onChange(e.target.value);
    };

    return (
        <InputContainer>
            <RequiredSectionTitle required={required}>{title}</RequiredSectionTitle>
            <StyledInput>
                <TextareaElement placeholder={placeholder} value={value} onChange={handleChange} />
            </StyledInput>
        </InputContainer>
    );
};
